import { createContext } from 'react';

const DarkBackground = createContext<boolean>(false);

export default DarkBackground;
